var _g, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularUserLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 108.00 108.00",
    width: 108,
    height: 108,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#889095",
    d: " M 68.94 36.00 A 14.94 14.94 0.0 0 0 54.00 21.06 A 14.94 14.94 0.0 0 0 39.06 36.00 A 14.94 14.94 0.0 0 0 54.00 50.94 A 14.94 14.94 0.0 0 0 68.94 36.00"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#889095",
    d: " M 54.00 86.98 C 61.31 86.98 68.54 84.63 74.56 80.21 C 77.80 77.83 78.62 75.13 77.61 71.44 Q 75.41 63.44 67.73 60.87 C 63.86 59.58 59.52 60.00 54.00 60.00 C 48.48 60.01 44.13 59.59 40.27 60.88 Q 32.59 63.45 30.39 71.45 C 29.38 75.14 30.20 77.84 33.45 80.22 C 39.46 84.64 46.70 86.98 54.00 86.98"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: " M 56.18 0.00 Q 65.45 0.86 69.20 2.10 Q 96.80 11.20 105.91 38.80 Q 107.13 42.50 108.00 51.74 L 108.00 56.03 Q 107.16 65.37 105.90 69.20 Q 96.79 96.80 69.18 105.91 Q 65.44 107.14 56.11 108.00 L 51.98 108.00 Q 42.55 107.14 38.81 105.90 Q 11.21 96.80 2.09 69.21 Q 0.85 65.45 0.00 56.12 L 0.00 51.89 Q 0.85 42.57 2.09 38.79 Q 11.21 11.21 38.80 2.09 Q 42.55 0.85 51.82 0.00 L 56.18 0.00 Z M 68.94 36.00 A 14.94 14.94 0.0 0 0 54.00 21.06 A 14.94 14.94 0.0 0 0 39.06 36.00 A 14.94 14.94 0.0 0 0 54.00 50.94 A 14.94 14.94 0.0 0 0 68.94 36.00 Z M 54.00 86.98 C 61.31 86.98 68.54 84.63 74.56 80.21 C 77.80 77.83 78.62 75.13 77.61 71.44 Q 75.41 63.44 67.73 60.87 C 63.86 59.58 59.52 60.00 54.00 60.00 C 48.48 60.01 44.13 59.59 40.27 60.88 Q 32.59 63.45 30.39 71.45 C 29.38 75.14 30.20 77.84 33.45 80.22 C 39.46 84.64 46.70 86.98 54.00 86.98 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#141414",
    cx: 54,
    cy: 36,
    r: 14.94
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: " M 54.00 60.00 C 59.52 60.00 63.86 59.58 67.73 60.87 Q 75.41 63.44 77.61 71.44 C 78.62 75.13 77.80 77.83 74.56 80.21 C 68.54 84.63 61.31 86.98 54.00 86.98 C 46.70 86.98 39.46 84.64 33.45 80.22 C 30.20 77.84 29.38 75.14 30.39 71.45 Q 32.59 63.45 40.27 60.88 C 44.13 59.59 48.48 60.01 54.00 60.00 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularUserLogo);
export default __webpack_public_path__ + "static/media/circular-user-logo.52a13e69638d65925bf50709d732b79b.svg";
export { ForwardRef as ReactComponent };